// extracted by mini-css-extract-plugin
export default {"page":"CX","heading":"EX","subheading":"FX","flavorbox":"GX","inner":"HX","image":"IX","label":"JX","flavorselect":"KX","arrow":"LX","flavorswrap":"MX","flavorsheader":"NX","flavorsnav":"OX","flavorsinner":"PX","cancelbtn":"QX","flavorsbottom":"RX","retakebtn":"SX","continueBtn":"TX","drawerinner":"UX","videowrap":"VX","flavorsbottomnav":"WX"};
    if(module.hot) {
      // 1721922367107
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  